import sendRequest from './sendRequest';
import '../config.js';

const BASE_PATH = global.constants.const_app_url;

export const toolGetData = ({}) =>
    sendRequest(BASE_PATH + "/tool", 'Post', {
        body: JSON.stringify({
        }),
    });
